import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingSpinner = ({ size = 'medium', text = '' }) => {
  const { t } = useTranslation();
  
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50">
      <div className="flex flex-col items-center">
        <div className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-gray-300 border-t-primary-600 shadow-lg`}></div>
        {text && (
          <p className="mt-4 text-gray-600 text-sm font-medium">{text}</p>
        )}
        {!text && (
          <p className="mt-4 text-gray-600 text-sm font-medium">{t('common.loading')}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
